var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    { staticClass: "mb-4" },
    [
      _c("b-col", { attrs: { cols: "12", "offset-sm": "1", sm: "3" } }, [
        _c("label", { attrs: { for: _vm.handle } }, [_vm._v(_vm._s(_vm.label))])
      ]),
      _c(
        "b-col",
        { attrs: { cols: "12", sm: "7" } },
        [
          _c("treeselect", {
            attrs: {
              id: _vm.handle,
              options: _vm.treeOptions,
              multiple: true,
              "flatten-search-results": true,
              "value-consists-of": "LEAF_PRIORITY",
              placeholder: _vm.$t("settings.plugins.leadModal.selectPage")
            },
            on: {
              input: function($event) {
                return _vm.$emit("update-field", $event)
              }
            },
            model: {
              value: _vm.selectedValues,
              callback: function($$v) {
                _vm.selectedValues = $$v
              },
              expression: "selectedValues"
            }
          }),
          _vm.desc
            ? _c("b-form-text", { domProps: { innerHTML: _vm._s(_vm.desc) } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }